export default {
  noFilter: [
    { sat: 255, hue: 0 },
    { sat: 255, hue: 360 },
  ],
  simulateCMYK: [
    { sat: 255, hue: 55 },
    { sat: 127, hue: 120 },
    { sat: 255, hue: 200 },
    { sat: 255, hue: 205 },
    { sat: 170, hue: 240 },
    { sat: 230, hue: 270 },
    { sat: 210, hue: 300 },
    { sat: 255, hue: 320 },
  ],
}
